module.exports = __webpack_public_path__ + "static/contact-706c3ddfeb9c7628bb79fc5bb76979aa.png";